import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Save, Info } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loading } from "@/components/common/Loading";
import { RichTextEditor } from "@/components/forms/RichTextEditor";

export default function AboutEditor() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/about").then(({ data }) => setC(data)).catch(() => toast.error("Could not load About content."));
  }, []);

  const set = (k, v) => setC((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/about", { heading: c.heading, body_html: c.body_html });
      setC(data);
      toast.success("About page saved — live on /about.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not save.");
    } finally { setSaving(false); }
  };

  if (!c) return <Loading />;

  return (
    <div data-testid="about-editor">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-[680] text-foreground"><Info className="h-5 w-5 text-primary" /> About page content</h2>
          <p className="text-sm text-muted-foreground">Edit the heading and body of <span className="font-[560]">/about</span> — changes go live instantly, no redeploy.</p>
        </div>
        <a href="/about" target="_blank" rel="noreferrer"><Button variant="secondary" data-testid="about-view-live">View live page</Button></a>
      </div>

      <div className="mt-6 space-y-5">
        <div className="space-y-1.5">
          <Label className="text-sm">Heading</Label>
          <Input value={c.heading || ""} onChange={(e) => set("heading", e.target.value)} data-testid="about-heading-input" placeholder="About Startup Otter" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-sm">Body</Label>
          <RichTextEditor
            value={c.body_html || ""}
            onChange={(v) => set("body_html", v)}
            placeholder="Write about Startup Otter…"
            testId="about-body-editor"
            toolbar={["bold", "italic", "underline", "heading", "bullet", "ordered", "link", "image"]}
            editorClassName="prose-so-spacious"
          />
        </div>
      </div>

      <div className="sticky bottom-4 mt-6 flex justify-end">
        <Button size="lg" onClick={save} disabled={saving} className="shadow-lg" data-testid="about-save-button"><Save className="mr-2 h-4 w-4" /> {saving ? "Saving…" : "Save changes"}</Button>
      </div>
    </div>
  );
}
